import React from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {MdDashboard, MdAttachMoney, MdBarcodeReader, MdFaceUnlock} from "react-icons/md";
import {FiList, FiUser, FiLock} from "react-icons/fi";
import {GiTurnstile} from "react-icons/gi";
import {HiOutlineTemplate, HiOutlineTicket} from "react-icons/hi";
import {BiDevices} from "react-icons/bi";
import {LuArrowLeftRight} from "react-icons/lu";
import {PiMapPinFill} from "react-icons/pi";
import {TfiStatsUp} from "react-icons/tfi";
import {SiAdguard} from "react-icons/si";
// ─── data ─────────────────────────────────────────────────────────────────────

const SECTIONS = [
    {
        title: "Dashboard",
        description: "Stav systému, služeb a statistiky průchodů za dnešní den.",
        icon: MdDashboard,
        links: [{label: "Otevřít dashboard", to: "/turnstile-dashboard"}],
    },
    {
        title: "Turnikety",
        description: "Správa turniketů a čteček — přidávání, editace, stav připojení.",
        icon: GiTurnstile,
        links: [
            {label: "Seznam turniketů", to: "/turnstile/list"},
            {label: "Spuštěné příkazy", to: "/turnstile/command"},
            {label: "Seznam šablon", to: "/turnstile/template"}
        ],
    },
    /*{
        title: "Mapa turniketů",
        description: "Interaktivní SVG mapa areálu — klikni na turniket pro detail a ovládání.",
        icon: PiMapPinFill,
        links: [{label: "Otevřít mapu", to: "/turnstile-map"}],
    },*/
    {
        title: "Tarify",
        description: "Tarifní systém — nastavení pravidel pro průchod a permanentky.",
        icon: MdAttachMoney,
        links: [{label: "Seznam tarifů", to: "/tariff"}],
    },
    {
        title: "Zařízení",
        description: "Displeje a brány napojené na turnikety.",
        icon: BiDevices,
        links: [{label: "Seznam zařízení", to: "/device"}],
    },
    {
        title: "Vstupenky",
        description: "Správa nahraných vstupenek a ruční kontrola konkrétního čipu.",
        icon: HiOutlineTicket,
        links: [
            {label: "Nahrané vstupenky", to: "/ticket/list"},
            {label: "Kontrola vstupenky", to: "/ticket/check"},
        ],
    },
    {
        title: "Průchody",
        description: "Záznamy průchodů turnikety — filtrování, export.",
        icon: LuArrowLeftRight,
        links: [{label: "Zobrazit průchody", to: "/entrance"}],
    },
    {
        title: "Zóny",
        description: "Zónová pravidla, kapacity a statistiky obsazenosti.",
        icon: PiMapPinFill,
        links: [
            {label: "Seznam zón", to: "/zone/list"},
            {label: "Statistiky zón", to: "/zone/stats"},
        ],
    },
    {
      title: "Rozpoznávání obličejů",
      description: "Statistiky pro rozpoznávání obličejů",
        icon:MdFaceUnlock,
        links:[
            {label: "Statistiky", to: "/face-recognition/stats"}
        ]
    },
    {
        title: "Přístupy",
        description: "Správa uživatelů a tokenů pro přístup do turniketového systému.",
        icon: SiAdguard,
        links: [
            {label: "Seznam uživatelů", to: "/access/user"},
            {label: "Seznam tokenů", to: "/access/token"}
        ],
    }
];

// ─── SectionCard ──────────────────────────────────────────────────────────────

const SectionCard = ({title, description, icon: Icon, links}) => (
    <div style={{
        border: "1px solid #bfdbfe",
        borderRadius: "10px",
        background: "#fff",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 1px 3px rgba(37,99,235,0.06)",
    }}>
        <div style={{padding: "14px 16px", flex: 1, display: "flex", flexDirection: "column", gap: "8px"}}>
            {/* header */}
            <div style={{display: "flex", alignItems: "center", gap: "9px"}}>
                <div style={{
                    width: "32px", height: "32px", borderRadius: "8px",
                    background: "#eff6ff", border: "1px solid #bfdbfe",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                    <Icon size={16} style={{color: "#2563eb"}}/>
                </div>
                <span style={{fontSize: "var(--enigoo-fs-md)", fontWeight: 700, color: "#1e293b"}}>{title}</span>
            </div>

            {/* description */}
            <p style={{margin: 0, fontSize: "var(--enigoo-fs-sm)", color: "#94a3b8", lineHeight: 1.5}}>{description}</p>

            {/* links */}
            <div style={{marginTop: "auto", paddingTop: "6px", display: "flex", flexWrap: "wrap", gap: "6px"}}>
                {links.map(({label, to, icon: LIcon}) => (
                    <Link key={to} to={to} style={{
                        display: "inline-flex", alignItems: "center", gap: "4px",
                        padding: "4px 11px",
                        background: "#eff6ff", color: "#2563eb",
                        border: "1px solid #bfdbfe",
                        borderRadius: "6px",
                        fontSize: "var(--enigoo-fs-xs)", fontWeight: 600,
                        textDecoration: "none",
                    }}>
                        {LIcon && <LIcon size={11}/>}
                        {label}
                    </Link>
                ))}
            </div>
        </div>
    </div>
);

// ─── main ─────────────────────────────────────────────────────────────────────

const ENIGOOTurnstileLanding = () => {
    const user = useSelector(s => s.user);

    return (
        <>
            <div style={{marginBottom: "18px"}}>
                <div style={{display: "flex", alignItems: "center", gap: "8px", marginBottom: "3px"}}>
                    <GiTurnstile size={18} style={{color: "#64748b"}}/>
                    <span style={{fontSize: "var(--enigoo-fs-2xl)", fontWeight: 700, color: "#1e293b"}}>Správa areálu</span>
                </div>
                <p style={{margin: 0, fontSize: "var(--enigoo-fs-sm)", color: "#94a3b8"}}>
                    Rozcestník pro správu turniketového systému
                    {user?.activeAreal?.name && <> — areál <strong style={{color: "#475569"}}>{user.activeAreal.name}</strong></>}
                </p>
            </div>

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: "12px",
            }}>
                {SECTIONS.map(section => (
                    <SectionCard key={section.title} {...section}/>
                ))}
            </div>
        </>
    );
};

export default ENIGOOTurnstileLanding;
